<template>
    <div
        id="supsis-right-modal"
        ref="supsisRightModal"
        class="supsis-right-modal-wrapper"
        :class="{ closed: closed, [type]: true, 'zero-padding': !! fullShow, 'footer-disabled': !footer }"
        :style="{ width, zIndex }"
        v-if="accessable"
    >
        <div class="action-buttons">
            <div class="btnWindow closeAction" @click="closeModal">
                <div class="material-icons">close</div>
            </div>
            <div
                class="btnWindow prevAction"
                :class="{ disabled: sliderOptions() && !sliderOptions().prevAvailable }"
                @click="() => (sliderOptions() && sliderOptions().prevAvailable ? sliderOptions().prev() : $_.noop())"
                v-if="sliderOptions()"
            >
                <div class="material-icons">arrow_back_ios</div>
            </div>
            <div
                class="btnWindow nextAction"
                :class="{ disabled: sliderOptions() && !sliderOptions().nextAvailable }"
                @click="() => (sliderOptions() && sliderOptions().nextAvailable ? sliderOptions().next() : $_.noop())"
                v-if="sliderOptions()"
            >
                <div class="material-icons">arrow_forward_ios</div>
            </div>
        </div>

        <div class="head" v-if="type !== 'show-visitor' && !fullShow">
            <div class="title" v-if="type === 'editor-task'" contenteditable="true" @input="updateTitle">
                {{ title }}
            </div>
            <div class="title" v-else>{{ title }}</div>
            <div class="description">{{ description }}</div>
        </div>
        <div class="content" :data-type="type.includes('table-record-viewer') ? 'table-record-viewer' : type">
            <a-spin :spinning="loading">
                <CreateTaskForm
                    v-if="type === 'create-task'"
                    :window-type="'create-task'"
                    v-bind="payload || {}"
                    @update-form="updateForm"
                    :attachmentEditVisible="false"
                />
                <WorkflowForm v-if="type === 'create-workflow'" @update-form="updateForm" />
                <TaskSettings v-if="type === 'task-settings'" @update-form="updateForm" />
                <EditorTask
                    v-if="type === 'editor-task'"
                    :details="payload"
                    @update-form="updateForm"
                    @close-modal="closeModal"
                />
                <PreviewTask v-if="type === 'preview-task'" :details="payload" />
                <CreateTaskForm
                    v-if="type === 'edit-task'"
                    :window-type="'edit-task'"
                    v-bind="payload"
                    @update-form="updateForm"
                    :attachmentFileVisible="false"
                />
                <VisibilityWorkFlow
                    v-if="type === 'visibility-workflow'"
                    :details="payload"
                    @update-form="updateForm"
                />
                <PipelineStageForm v-if="type === 'pipeline-edit'" @update-form="updateForm" :details="payload" />
                <WorkflowForm v-if="type === 'edit-workflow'" @update-form="updateForm" :details="payload" />
                <VisitorDetail v-if="type === 'show-visitor'" :visitorId="payload.visitorId" />
                <CalendarSettings v-if="type === 'calendar-settings'" :payload="payload" />
                <TaskArchive v-if="type === 'task-archive'" :workflow="payload.workflow" />
                <TaskDone v-if="type === 'task-done'" :workflow="payload.workflow" />
                <ChatCreateTaskForm
                    v-if="type === 'chat-create-task'"
                    :window-type="'chat-create-task'"
                    v-bind="payload || {}"
                    @update-form="updateForm"
                    :attachmentEditVisible="false"
                />
                <RecordViewer
                    v-if="type.includes('table-record-viewer')"
                    :tableId="payload.tableId"
                    :recordId="payload.recordId"
                    :defaultOpenTab="payload.defaultOpenTab"
                />
                <IDFinder v-if="type === 'id-finder'" />
                <GridChatWindowContact v-if="type === 'grid-chat-window-contact'" :contactId="payload.contactId" :disabled-resize="true" />
            </a-spin>
        </div>
        <div class="footer" v-if="footer && !fullShow">
            <div
                class="classic-submit-button"
                :class="{ disabled: saving }"
                @click="saveChanges(type)"
                :style="{ pointerEvents: saving ? 'none' : 'auto' }"
            >
                <a-icon v-if="type === 'create-task' && saving" type="loading" style="margin-right: 8px" />
                {{ $t("wp.saveChanges") }}
            </div>
            <div class="classic-submit-button" type="normal" @click="() => closeModal('cancel-button')">
                {{ $t("wp.cancel") }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import CreateTaskForm from "../task/CreateTaskForm.vue";
import WorkflowForm from "../task/WorkflowForm.vue";
import TaskSettings from "../task/Settings/Settings.vue";
import EditorTask from "../task/Settings/EditorTask.vue";
import EditTask from "../task/Settings/EditTask.vue";
import PreviewTask from "../task/Settings/PreviewTask.vue";
import PipelineStageForm from "../task/PipelineStageForm.vue";
import VisitorDetail from "../../views/Pages/Visitors/VisitorDetail.vue";
import CalendarSettings from "../../views/Pages/Calendar/CalendarSettings.vue";
import VisibilityWorkFlow from "../task/VisibilityWorkFlow.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import TaskArchive from "../task/Settings/TaskArchive.vue";
import ChatCreateTaskForm from "../task/ChatCreateTaskForm.vue";
import RecordViewer from "../../views/Pages/Tables/detail/RecordViewer.vue";
import TaskDone from "../task/Settings/TaskDone.vue";
import IDFinder from "../../views/Pages/Automation/components/IDFinder.vue";
import { publishMessage, SystemMessageTypes } from "../../utils/systemPubSub";
import GridChatWindowContact from "../popup-chat/chat-window/GridChatWindowContact.vue";

export default {
    name: "Window",
    components: {
        CreateTaskForm,
        WorkflowForm,
        TaskSettings,
        EditorTask,
        EditTask,
        PreviewTask,
        PipelineStageForm,
        VisitorDetail,
        CalendarSettings,
        VisibilityWorkFlow,
        TaskArchive,
        ChatCreateTaskForm,
        RecordViewer,
        TaskDone,
        IDFinder,
        GridChatWindowContact,
    },
    props: {
        title: {
            type: String,
        },
        description: {
            type: String,
        },
        type: {
            required: true,
            type: String,
        },
        width: {
            required: true,
            type: String,
        },
        zIndex: {
            required: true,
            type: Number,
        },
        loading: {
            type: Boolean,
        },
        fullShow: {
            type: Boolean,
            default: false,
        },
        footer: {
            type: Boolean,
            default: true,
        },
        payload: {
            type: Object,
        },
        window: {
            type: Object,
        },
        autoClose: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        closed: false,
        form: {},
        listeners: [],
        accessable: true,
        isModalOpen: false,
        saving: false,
    }),
    computed: {
        ...mapState({
            windows: (state) => state.app.windows,
            user: (state) => state.auth.user,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
            createTask: "tasks/createTask",
            createWorkflow: "tasks/createWorkflow",
            updateTask: "tasks/updateTask",
            updateWorkflow: "tasks/updateWorkflow",
        }),
        sliderOptions() {
            return this.window.sliderOptions;
        },
        closeModal(ignoreSource) {
            if (this.closed) {
                return;
            }
            console.log(`closeModal ${this.type} ignoreSource: ${ignoreSource}`);
            this.closed = true;
            this.isModalOpen = false;
            setTimeout(() => this.$emit("close", this.type), 500);
            if (this.payload?.onClose) {
                this.payload.onClose();
            }
            if (this.type === "editor-task") {
                const url = new URL(window.location.href);
                if (url.searchParams.has("taskId")) {
                    url.searchParams.delete("taskId");
                    window.history.replaceState({}, document.title, url.toString());
                }
                console.log("editor modal kapandı");
            }
        },
        updateForm(form) {
            if (this.type === "chat-create-task") {
                if (!form || !form.title || !form.description) {
                    this.form = null;
                    return;
                }
            }
            this.form = form;
        },
        async saveChanges(type) {
            if (this.saving) return;
            this.saving = true;

            if (type === "chat-create-task") {
                if (!this.form || !this.form.title || !this.form.description || this.form.description.trim() === "") {
                    this.$notification.error({
                        message: "Görev açıklama kısmı boş bırakılamaz",
                        description: "Görev açıklama kısmı boş bırakılamaz",
                    });
                    this.saving = false;
                    return;
                }

                if (
                    this.form.subTasks &&
                    this.form.subTasks.some((subTask) => !subTask.title || subTask.title.trim() === "")
                ) {
                    this.$notification.error({
                        message: "AltGörev başlığı boş bırakılamaz",
                        description: "AltGörev başlığı boş bırakılamaz",
                    });
                    this.saving = false;
                    return;
                }

                await this.createTask(this.form);
                this.$notification.success({
                    message: this.$t("task.taskCreatedMs"),
                    description: this.$t("task.taskCreatedMs"),
                });
                this.closeModal("saveChanges");
                this.payload?.onTaskCreated?.();
            } else if (type === "create-task") {
                if (
                    this.form.subTasks &&
                    this.form.subTasks.some((subTask) => !subTask.title || subTask.title.trim() === "")
                ) {
                    this.$notification.error({
                        message: "AltGörev başlığı boş bırakılamaz",
                        description: "AltGörev başlığı boş bırakılamaz",
                    });
                    this.saving = false;
                    return;
                }

                try {
                    const createdTask = await this.createTask(this.form);
                    publishMessage(SystemMessageTypes.TASK_CREATED, {
                        createdTask,
                    });
                    this.$notification.success({
                        message: this.$t("task.taskCreatedMs"),
                        description: this.$t("task.taskCreatedMs"),
                    });
                    this.payload?.onTaskCreated?.();
                    this.saving = false;
                    this.closeModal("saveChanges");
                } catch (error) {
                    this.$notification.error({
                        message: "Görev oluşturulurken hata oluştu",
                        description: error?.message || "Lütfen tekrar deneyiniz",
                    });
                    this.saving = false;
                    return;
                }
            } else if (type === "create-workflow") {
                await this.createWorkflow(this.form)
                    .then(() => {
                        this.$notification.success({
                            message: this.$t("task.workflowCreatedMs"),
                            description: this.$t("task.workflowCreatedMs"),
                        });
                    })
                    .catch(() => {
                        this.$notification.error({
                            message: this.$t("task.workflowCreateError"),
                            description: this.$t("task.workflowCreateError"),
                        });
                    });
                this.payload?.onTaskCreated?.();
            } else if (type === "editor-task") {
                this.updateTask({
                    taskId: this.payload.taskId,
                    params: {
                        ...this.form,
                    },
                }).then((updatedTask) => {
                    publishMessage(SystemMessageTypes.TASK_UPDATED, {
                        updatedTask,
                    });
                    this.$notification.success({
                        message: this.$t("task.taskUpdateMs"),
                        description: this.$t("task.taskUpdateMs"),
                    });
                    this.payload?.onTaskCreated?.();
                });
            } else if (type === "edit-task") {
                this.updateTask({
                    taskId: this.payload.taskId,
                    params: {
                        ...this.form,
                    },
                }).then((updatedTask) => {
                    publishMessage(SystemMessageTypes.TASK_UPDATED, {
                        updatedTask,
                    });
                    this.$notification.success({
                        message: this.$t("task.taskUpdateMs"),
                        description: this.$t("task.taskUpdateMs"),
                    });
                    this.payload?.onTaskCreated?.();
                });
            } else if (["visibility-workflow", "edit-workflow"].includes(type)) {
                this.updateWorkflow({
                    workflowId: this.payload.workflowId,
                    params: this.form,
                }).then(() => {
                    this.$notification.success({
                        message: this.$t("task.workflowUpdateMs"),
                        description: this.$t("task.workflowUpdateMs"),
                    });
                    this.payload?.onTaskCreated?.();
                });
            }

            if (type !== "create-task") {
                this.closeModal("saveChanges");
                this.saving = false;
            }
        },
        updateTitle(e) {
            this.form.title = e.target.innerText;
        },
    },
    mounted() {
        const fn = (e) => {
            if (e.key === "Escape") {
                const lastWindow = Object.keys(this.windows)[Object.keys(this.windows).length - 1];
                if (lastWindow === this.type) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    this.closeModal("escape last window");
                }
            }
        };

        const fn2 = (e) => {
            if (!this.autoClose) return;
            const dropdown = document.getElementsByClassName("ant-select-dropdown");
            const calendar = document.getElementsByClassName("ant-calendar-picker-container");
            const visitorDetail = document.getElementById("visitor-detail");
            const comment = document.getElementsByClassName("comment-body");
            const addTags = document.getElementsByClassName("add-tags");
            const visitorModal = document.getElementsByClassName("ant-modal-content");
            const modal = this.$refs.supsisRightModal;

            const isRecordViewer =
                Array.from(document.querySelectorAll(".record-viewer")).some((el) => el.contains(e.target)) ||
                e.target.classList.contains("record-viewer");
            const isCloseActionButton = Array.from(document.querySelectorAll(".closeAction")).some((el) =>
                el.contains(e.target)
            );
            const isModal = Array.from(document.querySelectorAll(".supsis-right-modal-wrapper")).some((el) =>
                el.contains(e.target)
            );
            const isAPopover = Array.from(document.querySelectorAll(".ant-popover")).some((el) =>
                el.contains(e.target)
            );

            console.log("isRecordViewer", {
                isRecordViewer,
                target: e.target,
                el: document.querySelector(".record-viewer"),
                isCloseActionButton,
                isAPopover,
            });
            if (
                (!visitorDetail || visitorDetail.length === 0) &&
                (!comment || comment.length === 0) &&
                (!dropdown || dropdown.length === 0) &&
                (!addTags || addTags.length === 0) &&
                (!calendar || calendar.length === 0) &&
                (!visitorModal || visitorModal.length === 0) &&
                !isRecordViewer &&
                !isCloseActionButton &&
                !isModal &&
                !isAPopover
            ) {
                this.closeModal("fn2");
            }
        };

        console.log("this.payload...", this.payload);
        
        // ESC tuşu için event listener'ı hemen ekle
        document.addEventListener("keydown", fn, true);
        this.listeners.push(() => {
            document.removeEventListener("keydown", fn, true);
        });
        
        // Click event listener'ı gecikme ile ekle
        if (!this.payload?.isOpenClick) {
            setTimeout(() => {
                document.addEventListener("click", fn2);
                this.listeners.push(() => {
                    document.removeEventListener("click", fn2);
                });
            }, 500);
        }

        this.isModalOpen = true;
    },
    created() {
        if (this.sliderOptions()) {
            const fn = (e) => {
                //if currenTarget is not input or textarea
                const isInput = e.target?.tagName === "INPUT" || e.target?.tagName === "TEXTAREA";
                if (!isInput) {
                    if (e.key === "ArrowRight" && this.sliderOptions().nextAvailable) {
                        this.sliderOptions().next();
                    } else if (e.key === "ArrowLeft" && this.sliderOptions().prevAvailable) {
                        this.sliderOptions().prev();
                    }
                }
            };
            document.addEventListener("keydown", fn);
            this.listeners.push(() => {
                document.removeEventListener("keydown", fn);
            });
        }
    },
    beforeDestroy() {
        this.listeners.forEach((fn) => fn());
    },
    watch: {
        "$route.path"() {
            this.closeModal("route change");
        },
    },
};
</script>
<style lang="scss" scoped>
@keyframes openEffect {
    from {
        transform: translate3d(80vw, 0, 0);
    }
    to {
        transform: translate3d(0, 0, 0);
    }
}

#supsis-right-modal {
    position: fixed;
    right: 0;
    width: 80vw;
    height: calc(100vh);
    background-color: white;
    border-left: 1px solid #dddddd;
    animation-name: openEffect;
    animation-duration: 0.1s;
    transition: all 0.1s;
    -webkit-box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);
    -moz-box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);
    box-shadow: -26px 8px 65px -31px rgba(0, 0, 0, 0.39);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    &.zero-padding {
        .content {
            padding: 0;
            height: 100% !important;
        }
    }
    &.footer-disabled {
        .content {
            height: 100% !important;
        }
    }

    &.closed {
        transform: translate3d(100vw, 0, 0);
    }

    &.show-visitor,
    &.id-finder {
        .content {
            padding: 0;

            #visitor-detail {
                width: 100%;
                overflow: hidden;
                height: 100%;
                // --default-color: red;
            }

            .ant-spin-nested-loading {
                height: 100%;
                .ant-spin-container {
                    height: 100% !important;
                }
            }
            .ant-spin-container {
                height: 100% !important;
            }
        }
    }

    .action-buttons {
        display: flex;
        flex-direction: column;
        position: absolute;
        left: -20px;
        top: 20px;
        z-index: 9999;
    }

    .btnWindow {
        background-color: white;
        border: 1px solid #dddddd;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        cursor: pointer;
        width: 30px;
        height: 30px;

        .material-icons {
            width: 14px;
            height: 14px;
            font-size: 17px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        &.disabled {
            cursor: not-allowed;
            background-color: #dddddd;
        }
    }

    .head {
        border-bottom: 1px solid #dddddd;
        padding: 20px;
        padding-left: 30px;

        .title {
            font-weight: bold;
            font-size: 18px;
        }

        .description {
            font-size: 14px;
        }
    }

    .content {
        padding: 20px;
        padding-left: 45px;
        overflow: auto;
        height: calc(100% - 140px);
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
    }

    &.show-visitor {
        .content {
            height: calc(100% - 50px);
        }
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        box-shadow: 0 -7.5px 15px -7.5px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 0px 20px;
        gap: 10px;
    }

    .classic-submit-button {
        background: #ec4b1d;
        color: white;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background-color: #f76036;
        }

        &.disabled {
            background: #ec4b1d;
            cursor: not-allowed;
        }

        &[type="normal"] {
            background-color: white;
            border: 1px solid #5c5a56;
            color: #5c5a56;

            &:hover {
                background-color: #5c5a56;
                color: white;
            }
        }
    }
}
</style>
<style lang="scss">
.id-finder {
    .ant-spin-nested-loading {
        height: 100%;
        .ant-spin-container {
            height: 100% !important;
        }
    }
    .ant-spin-container {
        height: 100% !important;
    }
}
#supsis-right-modal {
    .content {
        &[data-type="grid-chat-window-contact"] {
            height: 100% !important;
            overflow: hidden !important;
            #chat-window-wrapper {
                width: 65% !important;
                height: 100vh !important;
                overflow: hidden !important;
                #chatCloseSettingsButton {
                    min-height: 65px !important;
                    height: 65px !important;
                }
            }
           .user-info-widget {
                width: 35% !important;
                height: 100vh !important;
                .user-info-head {
                    min-height: 65px !important;
                    height: 65px !important;
                }
            }
        }
    }
}
</style>
